import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import ModalImage from "react-modal-image";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import CountUp from "react-countup";
import CurrencyInput from "react-currency-input-field";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetLegalityAssetState, getLegalityAsset } from "../../../store/legalityAsset/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetLegalStatusState, getLegalStatus } from "../../../store/legalStatus/action";
import { resetLegalState, getLegal as onGetLegals, addNewLegal as onAddNewLegal, updateLegal as onUpdateLegal, deleteLegal as onDeleteLegal, getLegalLoading, resetLegalCreateState } from "../../../store/legal/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
//import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { getNominatif, resetNominatifState, setBranchSelect, setCompanySelect } from "../../../store/actions";
import PrintDoc from "../../Task/PrintDoc";

const Legal = (props) => {
  const [pageIdx, setPageIdx] = useState(0);
  const [legalityDoc, setLegalityDoc] = useState([]);
  // const [legalList, setLegalList] = useState([]);
  const { t } = props;
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeab] = useState("all");
  const [modalAccPayable, setModalAccPayable] = useState(false);
  const [indexPage, setIndexPage] = useState(0);
  const [placeValue, setPlaceValue] = useState("");
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, legals, legalAdded, isLegalCreated, isLegalSuccess,
    loading, error, legalityAssets, legalityAssetLoading, companies, companyLoading, clients, clientLoading, departments, departmentLoading,
    branches, branchLoading, legalStatus, legalStatusLoading, nominatifs, nominatifLoading, budgets, budgetLoading } = useSelector((state) => ({
      clientSelected: state.App.clientSelected,
      companySelected: state.App.companySelected,
      branchSelected: state.App.branchSelected,
      userData: state.App.userData,
      userRole: state.App.userRole,
      userType: state.App.userType,
      legalAdded: state.Legal.legalAdded,
      legals: state.Legal.legals,
      loading: state.Legal.loading,
      isLegalCreated: state.Legal.isLegalCreated,
      isLegalSuccess: state.Legal.isLegalSuccess,
      error: state.Legal.error,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      departments: state.Department.departments,
      departmentLoading: state.Department.loading,
      legalStatus: state.LegalStatus.legalStatus,
      legalStatusLoading: state.LegalStatus.loading,
      legalityAssets: state.LegalityAsset.legalityAssets,
      legalityAssetLoading: state.LegalityAsset.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      budgets: state.Budget.budgets,
      budgetLoading: state.Budget.loading,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      nominatifs: state.Nominatif.nominatifs,
      nominatifLoading: state.Nominatif.loading,
    }));

  const [detailType, setDetailType] = useState(null);

  const [legalList, setLegalList] = useState([]);
  const [legal, setLegal] = useState([]);
  const [info, setInfo] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);
  const [profileFiles, setProfileFiles] = useState([]);
  const [detailFiles, setDetailFiles] = useState([]);

  const [isExportCSV, setIsExportCSV] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [nominatifList, setNominatifList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [currentImage, setCurrentImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(false);

  const [departmentData, setUserData] = useState(null);
  const [legalStatusList, setLegalStatusList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [modalMedia, setModalMedia] = useState(false);
  const [docImg, setDocImg] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const [landTotal, setLandTotal] = useState(false);
  const [landPaidTotal, setLandPaidTotal] = useState(false);
  const [landUnpaidTotal, setLandUnpaidTotal] = useState(false);
  const [priceTotal, setPriceTotal] = useState(false);
  const [paidTotal, setPaidTotal] = useState(false);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeab(type);
      let filteredLegals = legals;
      if (type !== "all") {
        filteredLegals = legals.filter((legal) => legal.statusLegalId === type);
      }
      setLegalList(filteredLegals);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    let land = 0;
    let landPaid = 0;
    let landUnpaid = 0;
    let price = 0;
    let paid = 0;
    for (const obj of legalList) {
      land = land + parseFloat(obj.quantity || 0);
      let pd = 0;
      for (const p of obj.legal_trans) {
        if (p.statusId === 2 || p.statusId === 3) pd = pd + parseFloat(p.amount || 0);
      }
      paid = paid + pd;
      price = price + parseFloat(obj.price || 0);

      landUnpaid += pd >= obj.price ? 0 : parseFloat(obj.quantity || 0);
      landPaid += pd >= obj.price ? parseFloat(obj.quantity || 0) : 0;
    }

    setLandTotal(land);
    setLandPaidTotal(landPaid);
    setLandUnpaidTotal(landUnpaid);
    setPaidTotal(paid);
    setPriceTotal(price);
  }, [legalList]);

  useEffect(() => {
    if (branchSelected) {
      handleGetLegal(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected]);

  const handleGetLegal = (id, branchId) => {
    dispatch(resetLegalState());
    dispatch(onGetLegals({ companyId: id, branchId: branchId, type: "asset" }));

    handleGetDepartment(id);
    handleGetLegalStatus();
    handleGetNominatif(id);
    handleGetLegalityAsset(id);
    handleGetBudget(id, branchId);
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetLegalityAsset = (id) => {
    dispatch(resetLegalityAssetState());
    dispatch(getLegalityAsset({ companyId: id }));
  };

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetLegalStatus = () => {
    dispatch(resetLegalStatusState());
    dispatch(getLegalStatus({ type: "asset" }));
  };

  const handleGetNominatif = (companyId) => {
    dispatch(resetNominatifState());
    dispatch(getNominatif({ companyId: companyId, statusId: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(legals)) {
      let filteredLegals = legals;
      if (activeTypeTab !== "all") {
        filteredLegals = legals.filter((legal) => legal.statusLegalId === activeTypeTab);
      }
      setLegalList(filteredLegals.map((el) => ({ ...el, isChecked: false })));
      const data = legals[legals.length - 1];
      if (info.id) {
        for (const obj of legals) {
          if (obj.id === info.id) {
            setInfo(obj);
            setLocationCord([obj.latitude, obj.longitude]);
          }
        }
      } else {
        setInfo(data);
        setLocationCord([data.latitude, data.longitude]);
      }
    }
    else {
      setLegalList([]);
      setInfo({});
    }
  }, [legals]);

  useEffect(() => {
    // let dataDoc = [
    //   {
    //     id: "name",
    //     label: "Area",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "nominatif",
    //     label: "Nomilatif",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "owner",
    //     label: "Pemilik Asal",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "quantity",
    //     label: "Luas",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "njop",
    //     label: "Harga",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "description",
    //     label: "Keterangan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_client",
    //     label: "Grup Usaha",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_company",
    //     label: "Perusahaan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_department",
    //     label: "Departemen",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_status",
    //     label: "Status",
    //     isSelected: true,
    //     data: []
    //   },
    // ]

    let dataDoc = [
      {
        id: "code",
        label: "NO BIDANG",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "LOKASI",
        isSelected: true,
        data: [],
      },
      {
        id: "owner",
        label: "NAMA",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "LUAS UKUR",
        isSelected: true,
        data: [],
      },
      {
        id: "",
        label: "LUAS SURAT",
        isSelected: true,
        data: [],
      },
      {
        id: "njop",
        label: "HARGA / M²",
        isSelected: true,
        data: [],
      },
      {
        id: "price",
        label: "JUMLAH",
        isSelected: true,
        data: [],
      },
      {
        id: "nominal",
        label: "NOMINAL BAYAR",
        isSelected: true,
        data: [],
      },
      {
        id: "sisa",
        label: "SISA BAYAR",
        isSelected: true,
        data: [],
      },
      {
        id: "sph",
        label: "SPH",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (legalList.length > 0) {
      legalList.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "code");
          if (doc) doc.data.push(data.code);

          doc = dataDoc.find((d) => d.id === "name");
          if (doc) doc.data.push(data.name);

          doc = dataDoc.find((d) => d.id === "owner");
          if (doc) doc.data.push(data.owner);

          doc = dataDoc.find((d) => d.id === "quantity");
          if (doc) doc.data.push(data.quantity ?? 0);

          doc = dataDoc.find((d) => d.id === "njop");
          if (doc) doc.data.push(data.njop ?? 0);

          doc = dataDoc.find((d) => d.id === "price");
          if (doc) doc.data.push(data.price ?? 0);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(data.description);
        }
      });
    }

    setLegalityDoc(dataDoc);
  }, [legalList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + ' - ' + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var data = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(legalStatus)) {
      var data = [];
      var opt = [];
      legalStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (legalStatus.length > 0) {
      setLegalStatusList(data);
    }
  }, [legalStatus]);

  useEffect(() => {
    if (!isEmpty(nominatifs)) {
      var data = [];
      var opt = [];
      nominatifs.forEach((item, key) => {
        const name = item.nama;
        const id = item.id;
        const luas_tanah = item.luas_tanah;
        const harga = item.harga;
        const nama = item.nama;
        const njop = item.njop;
        const no_c = item.no_c;
        var obj = { label: `${name}, ${luas_tanah}m2 - ${no_c}`, value: id, luas_tanah: luas_tanah, nama: nama, harga: harga, njop: njop };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (nominatifs.length > 0) {
      setNominatifList(data);
    }
  }, [nominatifs]);

  const onClickDelete = (legal) => {
    setLegal(legal);
    setDeleteModal(true);
  };

  const handleDeleteLegal = () => {
    if (legal) {
      dispatch(onDeleteLegal(legal));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegal(null);
      setAssetFiles([]);
      setDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback((type) => {
    if (modalDetail) {
      setModalDetail(false);
      setDetailType(null);
    } else {
      setModalDetail(true);
      setDetailType(type);
    }
  },
    [modalDetail]
  );

  const handleLegalClick = useCallback((arg, type) => {
    const data = arg;

    handleGetDepartment(data.companyId);
    handleGetNominatif(data.companyId);

    let legalDetail = [];
    if (data.legal_detail) {
      for (const element of data.legal_detail) {
        legalDetail.push({
          detailId: element.id,
          filename: element.filename,
          originalname: element.originalname,
          description: element.description,
        });
      }
    }
    setDetailFiles(legalDetail);

    let legalProfile = [];
    if (data.legal_profile) {
      for (const element of data.legal_profile) {
        legalProfile.push({
          detailId: element.id,
          filename: element.filename,
          originalname: element.originalname,
          description: element.description,
        });
      }
    }
    setProfileFiles(legalProfile);

    let arrLegal = [];
    if (data.legality && data.legality.length > 0) {
      for (const d of data.legality) {
        arrLegal.push(d);
      }
    } else {
      for (const d of legalityAssets) arrLegal.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
    }
    setCheckDocumentList(arrLegal);
    data.legality = arrLegal;

    let address_legal = {};
    for (const address of data.legal_address) {
      if (address.isPrimary) {
        address_legal = address;
      }
    }

    let files = [];
    for (const f of data.legal_file) {
      files.push({ filename: f.filename, originalname: f.originalname });
    }
    setAssetFiles(files);

    setLegal({
      id: data.id,
      companyId: data.companyId,
      clientId: data.clientId,
      description: data.description,
      street: address_legal.description ?? "",
      sph: data.sph ?? "",
      departmentId: data.departmentId,
      quantity: parseFloat(data.quantity),
      quantity_real: parseFloat(data.quantity_real),
      njop: parseFloat(data?.njop) || 0,
      price: parseFloat(data?.price) || 0,
      name: data.name,
      code: data.code,
      nominatif: data.legal_nominatif && { label: `${data.legal_nominatif.nama}, ${data.legal_nominatif.luas_tanah}m2 - ${data.legal_nominatif.no_c}`, value: data.legal_nominatif.id, harga: data?.legal_nominatif?.harga, njop: data?.legal_nominatif?.njop },
      owner: data?.legal_nominatif?.nama,
      pic: data.pic,
      latitude: data.latitude,
      longitude: data.longitude,
      branch: data.legal_branch && { label: data.legal_branch.name, value: data.legal_branch.id },
      company: data.legal_company && { label: data.legal_company.name, value: data.legal_company.id },
      client: data.legal_client && { label: data.legal_client.name, value: data.legal_client.id },
      department: data.legal_department && {
        label: data.legal_department.name,
        value: data.legal_department.id,
      },
      legal_status_legal: data.legal_status_legal && {
        label: data.legal_status_legal.name,
        value: data.legal_status_legal.id,
      },
      details: legalDetail,
      profiles: legalProfile,
      legality: data.legality,
    });

    setIsEdit(true);
    toggle();
  }, [toggle, legalityAssets]
  );

  const handleSalesClick = useCallback(
    (type) => {
      toggleDetail(type);
    },
    [toggleDetail, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      let price = parseFloat(data.price || 0);
      let amount = (data.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={legalList.find((x) => x.id === data.id).isChecked}
            onChange={() => {
              const updatedData = legalList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setLegalList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleLegalClick(data);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
              {/* <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  data.statusId = 3;
                  onClickDelete(data);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Button> */}
              <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-pernyataan-tidak-sengketa");
                  }}>
                  PRINT SURAT PERNYATAAN TIDAK SENGKETA
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-pernyataan-menghadap");
                  }}>
                  PRINT SURAT PERNYATAAN MENGHADAP
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-keterangan-status-tanah");
                  }}>
                  PRINT SURAT KETERANGAN STATUS TANAH
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-keterangan-riwayat-tanah");
                  }}>
                  PRINT SURAT KETERANGAN RIWAYAT TANAH
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-pernyataan-menjual");
                  }}>
                  PRINT SURAT PERNYATAAN MENJUAL
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-keterangan");
                  }}>
                  PRINT SURAT KETERANGAN
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-tabel");
                  }}>
                  PRINT BLANKO C
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-persetujuan-pasangan-atau-anak");
                  }}>
                  PRINT SURAT PERSETUJUAN PASANGAN ATAU ANAK
                </DropdownItem>
                {/* <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-persetujuan-anak");
                  }}>
                  PRINT SURAT PERSETUJUAN ANAK
                </DropdownItem> */}
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("a3-sph");
                  }}>
                  PRINT SURAT PERNYATAAN PELEPASAN HAK ATAS TANAH UNTUK KEPENTINGAN SWASTA
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  onClick={() => {
                    data.statusId = 3;
                    onClickDelete(data);
                  }}>
                  {" "}
                  HAPUS
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
            <button
              className={"btn me-2 btn-sm btn-soft-info"}
              onClick={() => {
                setInfo(data);
                toggleAccPayable();
              }}>
              <i className="ri-file-list-3-line fs-12 label-icon align-middle me-1"></i> INVOICE
            </button>
          </ButtonGroup>
        </div>
      );
    },
    id: "#",
  },
  {
    Header: "Nama",
    accessor: (data) => data?.nominatif,
    filterable: true,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            setInfo(data);
            setLocationCord([data.latitude, data.longitude]);
          }}>
          <div className="mb-1">{data?.nominatif || "NO NAME"}</div>
          <div className="hstack gap-2">
            <span className="badge fw-normal fs-9" style={{ backgroundColor: data?.legal_status_legal?.color, color: "#555  " }}>
              {data?.legal_status_legal?.name}
            </span>
            <span className="badge fw-normal text-dark fs-9 bg-soft-info">
              {data?.name}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    id: "Area",
    Header: "Area",
    accessor: "name",
    filterable: true,
  },
  {
    Header: "Luas",
    accessor: "quantity",
    filterable: true,
    Cell: (data) => (
      <span>
        {currencyFormat(data.value ? data.value : 0)} m<sup>2</sup>
      </span>
    ),
  },
  {
    Header: "Harga",
    accessor: "njop",
    filterable: true,
    Cell: (data) => <span>{currencyFormat(data.row.original?.njop || 0)}</span>,
  },
  {
    Header: "Total",
    accessor: "price",
    filterable: true,
    Cell: (data) => <span>{currencyFormat(data.row.original?.price || 0)}</span>,
  },
  {
    Header: "Terhutang",
    accessor: data => (data.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      let payable = (data.row.original.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span className="fw-semibold text-info">{currencyFormat(payable)}</span>
        </div>
      );
    },
  },
  {
    Header: "Terbayar",
    accessor: data => (data.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      let price = (data.row.original.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = (data.row.original.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span className={amount >= price ? "fw-semibold text-success" : amount > 0 && amount < price ? "fw-semibold text-warning" : "fw-semibold text-danger"}>{currencyFormat(amount)}</span>
        </div>
      );
    },
  },
  {
    Header: "Sisa Bayar",
    accessor: data => (data.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) - (data.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      let price = (data.row.original.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = (data.row.original.legal_trans || []).filter(element => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span className={amount >= price ? "fw-semibold text-success" : amount > 0 && amount <= price ? "fw-semibold text-warning" : "fw-semibold text-danger"}>{currencyFormat(price - amount < 0 ? 0 : price - amount)}</span>
        </div>
      );
    },
  },
  // {
  //   Header: "Tgl Input",
  //   accessor: "createdat",
  //   filterable: true,
  //   Cell: (data) => {
  //     return handleValidDate(data.row.original.createdat);
  //   },
  // },
  // {
  //   id: "Department",
  //   Header: "Departemen",
  //   accessor: "legal_department.name",
  //   filterable: true,
  //   Cell: (data) => <span className="fw-semibold">{data.row.original.pic && `${data.row.original.pic} / `}{data.value}</span>
  // },
  {
    id: "Status",
    Header: "Status",
    accessor: "legal_status_legal.name",
    filterable: true,
  }], [legalList, legalList, handleLegalClick, toggleHistory, userRole, userType, isCheckAll]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => legalList, [legalList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Department", "Status", "Area"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "inventory",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetLegals(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setLegalList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleGetLegal(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLegal(element.value));
    });
    checkall.checked = false;
  };

  function handleLegalDetailAdd(type) {
    if (type === "profile") setProfileFiles([...profileFiles, { filename: "", originalname: "", description: "" }]);
    else setDetailFiles([...detailFiles, { filename: "", originalname: "", description: "" }]);
  }

  const handleSelectFile = (file) => {
    if (currentImage === "detail") {
      detailFiles[currentImageIndex].filename = file.filename;
      detailFiles[currentImageIndex].originalname = file.originalname;
    } else if (currentImage === "profile") {
      profileFiles[currentImageIndex].filename = file.filename;
      profileFiles[currentImageIndex].originalname = file.originalname;
    } else {
      setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    }
    setCurrentImage(null);
    setCurrentImageIndex(null);
    toggleMedia();
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (legal && legal.id) || 0,
      company: (legal && legal.company) || companySelected,
      client: (legal && legal.client) || clientSelected,
      branch: (legal && legal.branch) || branchSelected,
      name: (legal && legal.name) ?? "",
      nominatif: (legal && legal.nominatif) ?? "",
      code: (legal && legal.code) ?? "",
      owner: (legal && legal.owner) ?? "",
      street: (legal && legal.street) ?? "",
      legal_status_legal: (legal && legal.legal_status_legal) ?? "",
      sph: (legal && legal.sph) ?? "",
      pic: (legal && legal.pic) ?? "",
      longitude: (legal && legal.longitude) ?? "",
      latitude: (legal && legal.latitude) ?? "",
      quantity: (legal && legal.quantity) || 0,
      quantity_real: (legal && legal.quantity_real) || 0,
      njop: (legal && legal.njop) || 0,
      price: (legal && legal.price) || 0,
      description: (legal && legal.description) ?? "",
      department: (legal && legal.department) ?? "",
      profiles: (legal && legal.profiles) ?? "",
      details: (legal && legal.details) ?? "",
      legality: (legal && legal.legality) || [],
    },
    validationSchema: Yup.object({
      nominatif: Yup.string().required("Isi Nama Pemilik Asal"),
      //nominatif: Yup.object().required("Isi Nama Nominatif"),
      //owner: Yup.string().required("Isi Nama Pemilk Asal"),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalLoading());
      if (isEdit) {
        let editSubmit = {
          type: "asset",
          id: values.id,
          name: values.name,
          nominatif: values.nominatif,
          code: values.code,
          owner: values.owner,
          pic: values.pic,
          description: values.description,
          street: values.street,
          sph: values.sph,
          statusLegalId: values.legal_status_legal.value,
          departmentId: values.department.value,
          longitude: values.longitude,
          latitude: values.latitude,
          quantity: values.quantity,
          quantity_real: values.quantity_real,
          njop: values.njop,
          price: values.price,
          branchId: values.branch.value,
          clientId: values.client.value,
          companyId: values.company.value,
          legal_profile: JSON.stringify(profileFiles),
          legal_detail: JSON.stringify(detailFiles),
          files: assetFiles.length > 0 ? assetFiles : [],
          legality: values.legality,
        };
        dispatch(onUpdateLegal(editSubmit));
      } else {
        let addSubmit = {
          type: "asset",
          name: values.name,
          nominatif: values.nominatif,
          code: values.code,
          owner: values.owner,
          pic: values.pic,
          sph: values.sph,
          description: values.description,
          statusLegalId: values.legal_status_legal.value,
          departmentId: values.department.value,
          longitude: values.longitude,
          latitude: values.latitude,
          quantity: values.quantity,
          quantity_real: values.quantity_real,
          njop: values.njop,
          price: values.price,
          branchId: values.branch.value,
          clientId: values.client.value,
          companyId: values.company.value,
          legal_profile: JSON.stringify(profileFiles),
          legal_detail: JSON.stringify(detailFiles),
          files: assetFiles.length > 0 ? assetFiles : [],
          legality: values.legality,
        };
        dispatch(onAddNewLegal(addSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      account: "",
      cashflow: "",
      description: `TANAH ASSET ${info?.nominatif + " - " + info?.name}`,
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount")
    }),
    onSubmit: (values) => {
      dispatch(getLegalLoading());
      info.setAccPayable = true;
      info.setApprove = false;
      info.transactionat = values.transactionat;
      info.budgetId = values.cashflow.value;
      info.accType = "PAYABLE";
      info.description = values.description;
      info.amount = values.amount;
      dispatch(onUpdateLegal(info));
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const onClickDeleteDetailItem = (filename, type) => {
    if (type === "profile") {
      const index = profileFiles.findIndex((fl) => fl.filename === filename);
      setProfileFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    } else {
      const index = detailFiles.findIndex((fl) => fl.filename === filename);
      setDetailFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  document.title = "Tanah Aset | Enterprise Resources Planning";

  return (
    <>
      <div className="page-content">
        <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={legalList} />
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegal} onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title="Pertanahan" pageTitle="TANAH ASSET" loading={loading}>
            <div className="flex-shrink-0">
              <button
                type="button"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLegal") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
                id="create-btn"
                onClick={() => {
                  setIsEdit(false);
                  let arrLegal = [];
                  for (const d of legalityAssets) arrLegal.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
                  setCheckDocumentList(arrLegal);
                  validation.setFieldValue("legality", arrLegal);
                  toggle();
                }}
              >
                <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
              </button>
              <ExportDoc data={legalityDoc} />
            </div>
          </BreadCrumb>
          <Row>
            <Col sm={12}>
              <div className="hstack gap-3">
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="" suffix={" M²"} separator="." end={landTotal} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Pembebasan Tanah</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="" suffix={" M²"} separator="." end={landPaidTotal} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Dibebaskan</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="" suffix={" M²"} separator="." end={landUnpaidTotal} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Belum Dibebaskan</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="Rp" suffix={""} separator="." end={priceTotal} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Estimasi Harga Tanah</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="Rp" suffix={""} separator="." end={paidTotal} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Terbayar</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="Rp" suffix={""} separator="." end={priceTotal - paidTotal} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Menunggu Pembayaran</div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-1 pb-0">
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> SEMUA TANAH ASET
                      </NavLink>
                    </NavItem>
                    {legalStatus.map((o, i) => (
                      <NavItem key={i}>
                        <NavLink
                          className={classnames({ active: activeTab === i + 2 }, "fw-semibold")}
                          onClick={() => {
                            toggleTab(i + 2, o.id);
                          }}
                          href="#"
                        >
                          <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> {o.name}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                  <Row className="mb-0">
                    <CardBody className="pb-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={9}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setLegalList(legals.map((el) => ({ ...el, isChecked: false })));
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg={9} style={{ position: "relative" }}>
              <Card style={{ position: "sticky", top: "94px" }}>
                <CardBody>
                  <div>
                    <div className="table-responsive table-card mb-1" style={{ minHeight: "380px" }}>
                      <Table hover {...getTableProps()} className="align-middle table-nowrap">
                        <thead className="table-info">
                          {headerGroups.map((headerGroup, index) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                              {headerGroup.headers.map((column, index) => (
                                <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                  {column.render("Header")}
                                  {generateSortingIndicator(column)}
                                  {/* <Filter column={column} /> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <Fragment key={row.getRowProps().key}>
                                <tr>
                                  {row.cells.map((cell, index) => {
                                    return (
                                      <td {...cell.getCellProps()} key={index}>
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                      <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex - 1);
                              previousPage();
                            }}
                            disabled={!canPreviousPage}
                          >
                            {"<"}
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-md-auto d-none d-md-block">
                        Halaman {pageIndex + 1} dari {pageOptions.length}
                      </Col>
                      <Col className="col-md-auto">
                        <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                      </Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex + 1);
                              nextPage();
                            }}
                            disabled={!canNextPage}
                          >
                            {">"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Modal id="showModal" isOpen={modal} centered size="xl">
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Aset Legalitas" : "Tambah Aset Legalitas"}
                    </ModalHeader>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}>
                      <ModalBody>
                        <CardBody className="border-bottom p-3 pt-0 pb-0 border-bottom-dashed">
                          <Row>
                            <Col lg={5}>
                              <div className="mb-3">
                                <Label htmlFor="latitude-field" className="form-label">
                                  Grup Usaha
                                </Label>
                                <div className="position-relative">
                                  <Select
                                    name="client"
                                    value={validation.values.client}
                                    isDisabled={userType === "admin" || userType === "client" ? false : true}
                                    placeholder="Pilih Grup Usaha"
                                    onChange={(e) => {
                                      validation.setFieldValue("client", e);
                                    }}
                                    options={clientList}
                                  ></Select>
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "-24px",
                                    }}
                                  >
                                    {clientLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.client && validation.errors.client && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.client}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="latitude-field" className="form-label">
                                  Perusahaan
                                </Label>
                                <div className="position-relative">
                                  <Select
                                    name="company"
                                    value={validation.values.company}
                                    placeholder="Pilih Perusahaan"
                                    isDisabled={userType === "admin" || userType === "client" ? false : true}
                                    onChange={(e) => {
                                      setDepartmentList([]);
                                      dispatch(setBranchSelect(null));
                                      dispatch(setCompanySelect(e));
                                      validation.setFieldValue("company", e);
                                      handleGetDepartment(e.value);
                                      handleGetNominatif(e.value);
                                    }}
                                    options={companyList}
                                  ></Select>
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "-24px",
                                    }}
                                  >
                                    {companyLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.company && validation.errors.company && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.company}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="address-field" className="form-label">
                                  {t("Cabang / Proyek")}
                                </Label>
                                <Select
                                  name="branch"
                                  value={validation.values.branch}
                                  placeholder="Pilih Proyek"
                                  onChange={(e) => {
                                    dispatch(setBranchSelect(e));
                                    validation.setFieldValue("branch", e);
                                  }}
                                  options={branchList}
                                ></Select>
                              </div>
                              {/* ////nominatif//// */}
                              <div className="mb-3">
                                <Label htmlFor="name-field" className="form-label">
                                  {t("Area")}
                                </Label>
                                <Input name="name" id="name-field" className="form-control" placeholder="Isi Lokasi Aset" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                              </div>
                              {/* <div className="mb-3">
                                <Label htmlFor="nominatif-field" className="form-label">
                                  Nominatif
                                </Label>
                                <div className="position-relative">
                                  <Select
                                    name="nominatif"
                                    value={validation.values.nominatif}
                                    placeholder="Pilih Nominatif"
                                    onChange={(e) => {
                                      validation.setFieldValue("nominatif", e);
                                      validation.setFieldValue("owner", e.nama);
                                      validation.setFieldValue("quantity", parseFloat(e.luas_tanah));
                                      validation.setFieldValue("quantity_real", parseFloat(e.luas_tanah));
                                      validation.setFieldValue("price", parseFloat(e.harga));
                                      validation.setFieldValue("njop", parseFloat(e.njop));
                                    }}
                                    options={nominatifList}
                                  ></Select>
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "-24px",
                                    }}
                                  >
                                    {nominatifLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.nominatif && validation.errors.nominatif && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.nominatif}
                                  </p>
                                )}
                              </div> */}
                              <div className='mb-3'>
                                <Label htmlFor='nominatif-field' className='form-label'>{t("Pemilik Asal")}</Label>
                                <Input name='nominatif' id='nominatif-field' className='form-control' placeholder='Isi Nama Pemilik Asal' type='text'
                                  validate={{ required: { value: true } }}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.nominatif ?? ""}
                                  invalid={validation.touched.nominatif && validation.errors.nominatif ? true : false} />
                                {validation.touched.nominatif && validation.errors.nominatif && (
                                  <FormFeedback type='invalid'>{validation.errors.nominatif}</FormFeedback>
                                )}
                              </div>

                              <div className="mb-3 d-none">
                                <Label htmlFor="code-field" className="form-label">
                                  {t("Kode Bidang")}
                                </Label>
                                <Input name="code" id="code-field" className="form-control" placeholder="Isi Nomor Bidang" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code ?? ""} invalid={validation.touched.code && validation.errors.code ? true : false} />
                                {validation.touched.code && validation.errors.code && <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>}
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="owner-field" className="form-label">
                                  {t("Balik Nama")}
                                </Label>
                                <Input name="owner" id="owner-field" className="form-control" placeholder="Isi Balik Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.owner ?? ""} invalid={validation.touched.owner && validation.errors.owner ? true : false} />
                                {validation.touched.owner && validation.errors.owner && <FormFeedback type="invalid">{validation.errors.owner}</FormFeedback>}
                              </div>
                              <div className="mb-3 col-lg-12 d-none">
                                <Label htmlFor="sph-field" className="form-label">
                                  {t("No SPH")}
                                </Label>
                                <Input name="sph" id="sph-field" className="form-control" placeholder="Isi No SPH" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sph} />
                              </div>
                              <div className="mb-3 d-none">
                                <Label htmlFor="des-field" className="form-label">
                                  {t("Keterangan")}
                                </Label>
                                <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                              </div>
                              <div className="row">
                                <div className="mb-3 col-lg-12">
                                  <Label htmlFor="active-status" className="form-label">
                                    Status
                                  </Label>
                                  <Select
                                    name="legal_status_legal"
                                    value={validation.values.legal_status_legal}
                                    placeholder="Pilih Status"
                                    onChange={(e) => {
                                      validation.setFieldValue("legal_status_legal", e);
                                    }}
                                    options={legalStatusList}
                                  ></Select>
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="quantity-field" className="form-label">
                                    {t("Luas Surat")}
                                  </Label>
                                  <Input name="quantity" id="quantity-field" className="form-control" placeholder="Isi Luas Tanah" type="number" validate={{ required: { value: true } }} onBlur={validation.handleBlur} value={validation.values.quantity}
                                    onChange={(e) => {
                                      validation.setFieldValue("quantity", e.target.value);
                                      if (validation.values.njop) {
                                        validation.setFieldValue("price", parseFloat(e.target.value) * parseFloat(validation.values.njop));
                                      }
                                    }} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="njop-field" className="form-label">
                                    {t("Harga Beli Per Meter")}
                                  </Label>
                                  <Input
                                    name="njop"
                                    id="njop-field"
                                    className="form-control"
                                    placeholder="Isi Harga Beli"
                                    type="number"
                                    validate={{ required: { value: true } }}
                                    onChange={(e) => {
                                      validation.setFieldValue("njop", e.target.value);
                                      if (validation.values.quantity) {
                                        validation.setFieldValue("price", parseFloat(e.target.value) * parseFloat(validation.values.quantity));
                                      }
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.njop}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="quantity_real-field" className="form-label">
                                    {t("Luas Ukur")}
                                  </Label>
                                  <Input name="quantity_real" id="quantity_real-field" className="form-control" placeholder="Isi Luas Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.quantity_real} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="price-field" className="form-label">
                                    {t("Harga Pembelian")}
                                  </Label>
                                  <Input name="price" id="price-field" className="form-control" placeholder="Isi Harga Pembelian Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.price} />
                                </div>
                              </div>
                              <div className="mb-3 d-none">
                                <Label htmlFor="street-field" className="form-label">
                                  {t("Alamat")}
                                </Label>
                                <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street ?? ""} />
                              </div>

                              {(clientLoading || companyLoading) && (
                                <div className="position-absolute top-0">
                                  <Spinner color="primary" type="grow" size={"sm"}>
                                    Loading...
                                  </Spinner>
                                  &nbsp;
                                  <Spinner color="success" type="grow" size={"sm"}>
                                    Loading...
                                  </Spinner>
                                  &nbsp;
                                </div>
                              )}
                            </Col>
                            <Col lg={7} className="ps-3">
                              <div className="mb-3">
                                <div className="row">
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="pic-field" className="form-label">
                                      {t("PIC Aset")}
                                    </Label>
                                    <Input name="pic" id="pic-field" className="form-control" placeholder="Isi PIC Aset" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.pic} />
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="address-field" className="form-label">
                                      {t("Departemen")}
                                    </Label>
                                    <Select
                                      name="department"
                                      value={validation.values.department}
                                      placeholder="Pilih Departemen"
                                      onChange={(e) => {
                                        validation.setFieldValue("department", e);
                                      }}
                                      options={departmentList}
                                    ></Select>
                                  </div>
                                  <div className="mb-3 col-lg-6 ">
                                    <Label htmlFor="latitude-field" className="form-label">
                                      Latitude
                                    </Label>
                                    <Input name="latitude" id="latitude-field" className="form-control" placeholder="Isi Latitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.latitude ?? ""} />
                                  </div>
                                  <div className="mb-3 col-lg-6 ">
                                    <Label htmlFor="longitude-field" className="form-label">
                                      Longitude
                                    </Label>
                                    <Input name="longitude" id="longitude-field" className="form-control" placeholder="Isi Longitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longitude ?? ""} />
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <Label htmlFor="des-field" className="form-label">
                                    {t("Keterangan")}
                                  </Label>
                                  <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                                </div>

                                <div className="mb-3 d-flex justify-content-between">
                                  <Label htmlFor="taskFiles" className="form-label me-3">
                                    Foto Area
                                  </Label>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-label btn-soft-success"
                                    onClick={() => {
                                      toggleMedia();
                                    }}
                                  >
                                    <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                  </button>
                                </div>
                                {assetFiles.map((assetFile, i) => {
                                  if (assetFile.isDeleted) {
                                    return null;
                                  } else {
                                    return (
                                      <div key={i} className="border-bottom mb-3">
                                        <div className="d-flex justify-content-between mb-3 align-items-center">
                                          <div className="me-2">
                                            <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                          </div>
                                          <div className="text-truncate">{assetFile.originalname}</div>
                                          <div>
                                            <Link
                                              to="#"
                                              className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                              onClick={(e) => {
                                                handleDeleteFile(assetFile);
                                              }}
                                            >
                                              <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                })}

                                <h5 className="mb-3 border-bottom pb-3">Legalitas Dokumen</h5>
                                <div className="d-none">
                                  {legalityAssets.map((o, idx) => {
                                    if (validation.values.legality.length > 0) {
                                      return (
                                        <div key={idx} className="row ms-1">
                                          <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-6">
                                            <Input
                                              className={"form-check-input checked-all checked-method-all check-" + o.id + idx}
                                              type="checkbox"
                                              role="switch"
                                              value={validation.values.legality[idx]?.id}
                                              defaultChecked={o.id === validation.values.legality[idx]?.id && validation.values.legality[idx]?.id !== 0 ? true : false}
                                              onChange={(e) => {
                                                if (e.target.checked) validation.setFieldValue(`legality[${idx}].id`, o.id);
                                                else validation.setFieldValue(`legality[${idx}].id`, 0);
                                              }}
                                            />
                                            <Label className="form-check-label text-dark text-uppercase fs-12" htmlFor={"check-" + o.id + idx}>
                                              {o.name}
                                            </Label>
                                          </div>
                                          <div className="mb-2 col-lg-2 d-none">
                                            <Flatpickr
                                              className="form-control"
                                              placeholder="Target"
                                              options={{ mode: "single", dateFormat: "Y/m/d" }}
                                              onChange={(selectedDates, dateStr) => {
                                                validation.setFieldValue(`legality[${idx}].targetat`, dateStr);
                                              }}
                                              value={validation.values.legality[idx]?.targetat}
                                            />
                                          </div>
                                          <div className="mb-2 col-lg-2 d-none">
                                            <Flatpickr
                                              className="form-control"
                                              placeholder="Actual"
                                              options={{ mode: "single", dateFormat: "Y/m/d" }}
                                              onChange={(selectedDates, dateStr) => {
                                                if (validation.values.legality[idx]) validation.values.legality[idx].actualat = dateStr;
                                              }}
                                              value={validation.values.legality[idx]?.actualat}
                                            />
                                          </div>
                                          <div className="mb-2 col-lg-6">
                                            <Input
                                              type="textarea"
                                              className="form-control"
                                              placeholder="Keterangan jika ada"
                                              value={validation.values.legality[idx]?.description}
                                              onChange={(e) => {
                                                validation.setFieldValue(`legality[${idx}].description`, e.target.value);
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    } else return null;
                                  })}
                                </div>
                              </div>
                              <div>
                                <div className="justify-content-between mb-3 border border-top-0 border-start-0 border-end-0 pb-2">
                                  <span className="text-muted mt-2 me-2 text-uppercase fw-semibold">UPLOAD DATA DIRI</span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-soft-success"
                                    onClick={() => {
                                      handleLegalDetailAdd("profile");
                                    }}
                                  >
                                    <i className="ri-add-fill fs-12 me-1"></i>Tambah
                                  </button>
                                </div>
                                <div>
                                  {profileFiles &&
                                    profileFiles.map((file, i) => {
                                      return (
                                        <div key={i}>
                                          {file.filename && (
                                            <p
                                              className="fs-18 m-1 text-info"
                                              onClick={() => {
                                                const typeFile = file.filename.split(".");
                                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else {
                                                  //
                                                }
                                              }}
                                            >
                                              {renderIcon(file.filename)} <span className="fs-12 fw-normal">{file.originalname}</span>
                                            </p>
                                          )}
                                          <div className="d-flex justify-content-between mb-2">
                                            <Input
                                              placeholder="Keterangan"
                                              type="text"
                                              className="form-control me-2 product-price w-100"
                                              value={profileFiles[i].description}
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) => {
                                                profileFiles[i].description = e.target.value;
                                              }}
                                              onBlur={validation.handleBlur}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-soft-success btn-sm me-2"
                                              onClick={(e) => {
                                                toggleMedia();
                                                setCurrentImage("profile");
                                                setCurrentImageIndex(i);
                                              }}
                                            >
                                              <i className=" ri-file-2-line fs-15"></i>
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-soft-danger btn-sm me-2"
                                              onClick={(e) => {
                                                onClickDeleteDetailItem(file.filename, "profile");
                                              }}
                                            >
                                              <i className=" ri-delete-bin-line fs-15 text-danger"></i>
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                                <div className="justify-content-between mb-3 mt-3 border border-top-0 border-start-0 border-end-0 pb-2">
                                  <span className="text-muted mt-2 me-2 text-uppercase fw-semibold">UPLOAD LEGALITAS</span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-soft-success"
                                    onClick={() => {
                                      handleLegalDetailAdd("detail");
                                    }}
                                  >
                                    <i className="ri-add-fill fs-12 me-1"></i>Tambah
                                  </button>
                                </div>
                                <div>
                                  {detailFiles &&
                                    detailFiles.map((file, i) => {
                                      return (
                                        <div key={i + "legal"}>
                                          {file.filename && (
                                            <p
                                              className="fs-18 m-1 text-info"
                                              onClick={() => {
                                                const typeFile = file.filename.split(".");
                                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else {
                                                  //
                                                }
                                              }}
                                            >
                                              {renderIcon(file.filename)} <span className="fs-12 fw-normal">{file.originalname}</span>
                                            </p>
                                          )}
                                          <div className="d-flex justify-content-between mb-2">
                                            <Input
                                              placeholder="Keterangan"
                                              type="text"
                                              className="form-control me-2 product-price w-100"
                                              value={detailFiles[i].description}
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) => {
                                                detailFiles[i].description = e.target.value;
                                              }}
                                              onBlur={validation.handleBlur}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-soft-success btn-sm me-2"
                                              onClick={(e) => {
                                                toggleMedia();
                                                setCurrentImage("detail");
                                                setCurrentImageIndex(i);
                                              }}
                                            >
                                              <i className=" ri-file-2-line fs-15"></i>
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-soft-danger btn-sm me-2"
                                              onClick={(e) => {
                                                onClickDeleteDetailItem(file.filename, "detail");
                                              }}
                                            >
                                              <i className=" ri-delete-bin-line fs-15 text-danger"></i>
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </ModalBody>
                      <div className="modal-footer">
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                              validation.resetForm({});
                            }}
                          >
                            TUTUP
                          </button>

                          <button type="submit" className="btn btn-success" disabled={loading}>
                            <span className="d-flex align-items-center">
                              SIMPAN
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </Form>
                  </Modal>
                  <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card className="table-responsive">
                <div className="card-body">
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Dokumen Legalitas:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.legal_detail || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "file"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Dokumen Data Diri:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.legal_profile || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "filehak"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <h6 className="fw-semibold mb-2">Keterangan</h6>
                  <p className="mb-4">{info.description ? info.description : "-"} </p>
                  <div className="table-card p-3">
                    <Row>
                      <Col xxl={12}>
                        <table className="table border table-responsive fs-13 mb-3 d-none">
                          <tbody>
                            <tr>
                              <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                PROGRESS PEMBEBASAN LAHAN
                              </td>
                            </tr>
                            {info.legality &&
                              info.legality.map((o, idx) => {
                                let row = o || {};
                                return (
                                  <Fragment key={idx}>
                                    <tr>
                                      <td className="p2 border-top-0">
                                        {/* {row.targetat ? row.targetat : "-"} s.d {row.actualat ? row.actualat : "-"} */}
                                        <span className="fw-semibold">
                                          <i className={row.id ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line text-danger me-1"}></i> {row.name ? row.name : "-"}
                                        </span>
                                        ,
                                      </td>
                                    </tr>
                                    {row.description && row.description !== "" && (
                                      <>
                                        <tr>
                                          <td className="p2 border-0">{row.description ? row.description : "-"}</td>
                                        </tr>
                                      </>
                                    )}
                                  </Fragment>
                                );
                              })}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                </div>
                <CardBody className="text-center">
                  <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                    <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={locationCord}>
                      <Popup>{info.branch_branch && info.branch_branch.name ? info.branch_branch.name : "-"}</Popup>
                    </Marker>
                  </MapContainer>
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Foto Lokasi Pertanahan:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-2 pt-3 pb-3">
                          <div className="row">
                            {info.legal_file &&
                              info.legal_file.length > 0 &&
                              info.legal_file.map((f, i) => {
                                return (
                                  <div key={i} className="col-lg-4">
                                    <div className="position-relative d-inline-block mx-auto">
                                      <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table border table-responsive fs-13 mb-3">
                    <tbody>
                      <tr>
                        <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          INFORMASI LAINNYA
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Perusahaan</td>
                        <td className="p-2">{info.legal_company && info.legal_company.name ? info.legal_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Area</td>
                        <td className="p-2">
                          {info.latitude}, {info.longitude}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info.legal_createdby && info.legal_createdby.name ? info.legal_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info.legal_updatedby && info.legal_updatedby.name ? info.legal_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
            TAGIHAN {info?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayable.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    prefix="Rp. "
                    style={{ border: "1px solid #ccc" }}
                    className="form-control product-price"
                    placeholder="Terbayar"
                    value={validationAccPayable.values.amount}
                    decimalsLimit={2}
                    onFocus={(e) => e.target.select()}
                    onValueChange={(value, name, values) => {
                      validationAccPayable.setFieldValue("amount", parseFloat(value));
                    }}
                  />
                  {validationAccPayable.touched.amount && validationAccPayable.errors.amount && <p className="invalid-feedback d-block" type="invalid">{validationAccPayable.errors.amount}</p>}
                </div>
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Tagihan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayable.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayable.values.transactionat ?? ""} />
                </div>
                <div className="mb-3 col-lg-4">
                  <Label className="form-label">
                    Cashflow
                  </Label>
                  <Select
                    name="cashflow"
                    value={validationAccPayable.values.cashflow}
                    placeholder="Pilih Cashflow"
                    onChange={(e) => {
                      validationAccPayable.setFieldValue("cashflow", e);
                    }}
                    options={budgetList}></Select>
                  {validationAccPayable.touched.cashflow && validationAccPayable.errors.cashflow && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.cashflow}
                    </small>
                  )}
                </div>
                <div className="mb-3">
                  <Label htmlFor="address-field" className="form-label">
                    Keterangan
                  </Label>
                  <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                  {validationAccPayable.touched.description && validationAccPayable.errors.description && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.description}
                    </small>
                  )}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayable(false);
                    validationAccPayable.resetForm();
                  }}>
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            {`View ${detailType}`}
          </ModalHeader>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalDetail(false);
                }}
              >
                TUTUP
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default withRouter(withTranslation()(Legal));
